import type { DomainMapper } from '../types';

const base = {
  countryCode: 'no',
  currency: 'NOK',
  dataAreaId: 'no32',
  environment: 'production',
  flagUrl: '/flags/NO.svg',
  languagePrimary: true,
  locale: 'no',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'produkt',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-no.xml',
  storyblokBasePath: 'no',
  algoliaIndex: 'b2b-no-nb-NO-products',
  algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1356,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1356,
    algoliaIndex: 'b2b-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-no.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1474,
    algoliaIndex: 'b2c-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2c-no-nb-NO-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-no-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    sampleRequestNav: true,
    disableShipToConsumer: true,
  },
  showNonPublicProducts: false,
};

const no: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default no;
